import type {
	FillLayerSpecification,
	LineLayerSpecification,
	CircleLayerSpecification,
	SymbolLayerSpecification,
} from "maplibre-gl";

// ── Standard layers ─────────────────────────────────────────────────────────

export const polygonFillLayer: FillLayerSpecification = {
	id: "polygon-fill",
	type: "fill",
	source: "polygons",
	paint: {
		"fill-color": ["get", "color"],
		"fill-opacity": ["coalesce", ["get", "fillOpacity"], ["get", "opacity"], 0.4],
	},
};

export const polygonLineLayer: LineLayerSpecification = {
	id: "polygon-line",
	type: "line",
	source: "polygons",
	paint: {
		"line-color": ["coalesce", ["get", "strokeColor"], ["get", "color"]],
		"line-width": ["coalesce", ["get", "strokeWeight"], 2],
		"line-opacity": ["coalesce", ["get", "strokeOpacity"], 1],
	},
};

export function pointCircleLayer(minzoom: number): CircleLayerSpecification {
	return {
		id: "point-circles",
		type: "circle",
		source: "points",
		minzoom,
		paint: {
			"circle-radius": 7,
			"circle-color": ["get", "color"],
			"circle-stroke-width": 1.5,
			"circle-stroke-color": "#666",
		},
	};
}

export function pointLabelLayer(minzoom: number): SymbolLayerSpecification {
	return {
		id: "point-labels",
		type: "symbol",
		source: "points",
		minzoom,
		layout: {
			"text-field": ["get", "label"],
			"text-size": 13,
			"text-offset": [0, 0.8],
			"text-anchor": "top",
		},
		paint: {
			"text-color": "#fff",
			"text-halo-color": "#000",
			"text-halo-width": 1,
		},
	};
}

// ── Wizard layers ───────────────────────────────────────────────────────────

export const hatchLineLayer: LineLayerSpecification = {
	id: "hatch-lines",
	type: "line",
	source: "hatch-lines",
	paint: {
		"line-color": ["get", "color"],
		"line-width": ["coalesce", ["get", "strokeWeight"], 1.5],
		"line-opacity": ["coalesce", ["get", "strokeOpacity"], 0.8],
	},
};

export const nearbyFillLayer: FillLayerSpecification = {
	id: "nearby-jobs-fill",
	type: "fill",
	source: "nearby-jobs",
	paint: {
		"fill-color": ["get", "color"],
		"fill-opacity": ["coalesce", ["get", "fillOpacity"], 0.2],
	},
};

export const nearbyLineLayer: LineLayerSpecification = {
	id: "nearby-jobs-line",
	type: "line",
	source: "nearby-jobs",
	paint: {
		"line-color": ["coalesce", ["get", "strokeColor"], ["get", "color"]],
		"line-width": ["coalesce", ["get", "strokeWeight"], 2],
		"line-opacity": ["coalesce", ["get", "strokeOpacity"], 0.5],
	},
};

export const unmatchedPointsLayer: CircleLayerSpecification = {
	id: "unmatched-points",
	type: "circle",
	source: "unmatched-points",
	paint: {
		"circle-radius": ["coalesce", ["get", "size"], 7],
		"circle-color": ["get", "color"],
		"circle-stroke-width": ["coalesce", ["get", "strokeWidth"], 2],
		"circle-stroke-color": ["coalesce", ["get", "strokeColor"], "#fff"],
	},
};

export const unmatchedZonesFillLayer: FillLayerSpecification = {
	id: "unmatched-zones-fill",
	type: "fill",
	source: "unmatched-zones",
	paint: {
		"fill-color": ["get", "color"],
		"fill-opacity": ["coalesce", ["get", "fillOpacity"], 0.4],
	},
};

export const unmatchedZonesLineLayer: LineLayerSpecification = {
	id: "unmatched-zones-line",
	type: "line",
	source: "unmatched-zones",
	paint: {
		"line-color": ["coalesce", ["get", "strokeColor"], ["get", "color"]],
		"line-width": ["coalesce", ["get", "strokeWeight"], 3],
	},
};

export const duplicatePointsLayer: CircleLayerSpecification = {
	id: "duplicate-points",
	type: "circle",
	source: "duplicate-points",
	paint: {
		"circle-radius": ["coalesce", ["get", "size"], 7],
		"circle-color": ["get", "color"],
		"circle-stroke-width": ["coalesce", ["get", "strokeWidth"], 2],
		"circle-stroke-color": ["coalesce", ["get", "strokeColor"], "#fff"],
	},
};

export const duplicateZonesFillLayer: FillLayerSpecification = {
	id: "duplicate-zones-fill",
	type: "fill",
	source: "duplicate-zones",
	paint: {
		"fill-color": ["get", "color"],
		"fill-opacity": ["coalesce", ["get", "fillOpacity"], 0.4],
	},
};

export const duplicateZonesLineLayer: LineLayerSpecification = {
	id: "duplicate-zones-line",
	type: "line",
	source: "duplicate-zones",
	paint: {
		"line-color": ["coalesce", ["get", "strokeColor"], ["get", "color"]],
		"line-width": ["coalesce", ["get", "strokeWeight"], 3],
	},
};

export const highlightFillLayer: FillLayerSpecification = {
	id: "highlight-fill",
	type: "fill",
	source: "highlight",
	paint: {
		"fill-color": ["get", "color"],
		"fill-opacity": ["coalesce", ["get", "fillOpacity"], 0.3],
	},
};

export const highlightLineLayer: LineLayerSpecification = {
	id: "highlight-line",
	type: "line",
	source: "highlight",
	paint: {
		"line-color": ["coalesce", ["get", "strokeColor"], ["get", "color"]],
		"line-width": ["coalesce", ["get", "strokeWeight"], 2],
	},
};
